import React, { createContext, useState, useContext } from "react";

// Creating the Context
const RentFilterContext = createContext();

// Creating a custom hook to use the context
export const useRentFilter = () => {
  return useContext(RentFilterContext);
};

// Creating the Provider component
export const RentFilterProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

 

  return (
    <RentFilterContext.Provider
      value={{
        selectedLocation,
        selectedRoom,
        selectedPrice,
        filteredUsers,
        isFilterApplied,
        setSelectedLocation,
        setSelectedRoom,
        setSelectedPrice,
        setFilteredUsers,
        setIsFilterApplied
        // handleClearFilters,
        // handleSearch,
      }}
    >
      {children}
    </RentFilterContext.Provider>
  );
};